import api from './api';

export interface Location {
  id: string;
  name: string;
  address: string;
  whatsappNumber?: string;
}

export interface LocationListResponse {
  data: Location[];
}

export const locationService = {
  // Get all active locations
  async getLocations(): Promise<Location[]> {
    const response = await api.get<LocationListResponse>('/locations/public');
    return response.data.data;
  },
};